import React from 'react';

const HeroSection = () => {
  return (
    <section
      className="relative h-[90vh] bg-cover bg-center flex items-center justify-center"
      style={{
        backgroundImage: `url('/img/portada.png')`, // ✅ Ruta desde /public
      }}
    >
      {/* Capa gris semitransparente */}
      <div className="absolute inset-0 bg-gray-900 bg-opacity-50 z-0"></div>

      {/* Contenido */}
      <div className="relative z-10 container mx-auto px-6 text-center text-white">
        <h1 className="text-4xl md:text-5xl font-bold mb-6">
          Transformamos ideas en soluciones digitales
        </h1>
        <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto">
          Expertos en desarrollo de plataformas educativas, marketing digital, turismo y comercio electrónico.
        </p>
      </div>

      {/* Decorativo blanco inferior */}
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-white z-10"></div>
    </section>
  );
};

export default HeroSection;
